import { render, staticRenderFns } from "./ace-editor-js.vue?vue&type=template&id=31753c4b&"
import script from "./ace-editor-js.vue?vue&type=script&lang=js&"
export * from "./ace-editor-js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31753c4b')) {
      api.createRecord('31753c4b', component.options)
    } else {
      api.reload('31753c4b', component.options)
    }
    module.hot.accept("./ace-editor-js.vue?vue&type=template&id=31753c4b&", function () {
      api.rerender('31753c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/common/ace-editor-js.vue"
export default component.exports